import { NotificationIdentifierModel } from './notification-identifier.model';

export class NotificationTimerModel {
    public constructor(
        public notificationId: NotificationIdentifierModel,
        public timer: number,
    ) {}
}
